<template>
    <form action="" class="one-time-payment-form">
        <OptionTilesHeading v-html="paymentAmountTilesHeading" />

        <div class="row amounts">
            <div
                v-for="(amount, index) in amountList"
                class="amount-block"
                :key="index">
                <Box
                    :chosen="(amount == currentAmount) && !isOtherValue"
                    @click="selectPaymentAmountItem(amount)"
                >
                    <span class="amount">{{ amount }}</span>
                    <span class="currency">zł</span>
                </Box>
            </div>
            <div class="amount-block">
                <Box
                    :chosen="isOtherValue"
                    @keyup="()=>{currentAmount = amountOther;}"
                    @click="selectPaymentAmountItem('')"
                >
                    <PInput
                        :tag="'input'"
                        v-model="amountOther"
                        :type="'number'"
                        :name="'amount_other'"
                        :extraClass="'other-amount'"
                        :placeholder="'inna kwota'"
                        v-validate="validationRules.amountOtherValidation(isAmountOther(+currentAmount))"
                        data-vv-scope="one-time-payment-form"
                        @wheel.prevent />
                </Box>
            </div>
        </div>
        <div class="row amount-error">
            <div class="col-12">
                <Error :fieldName="'one-time-payment-form.amount_other'"/>
            </div>
        </div>

        <HorizontalSeparator />

        <OptionTilesHeading v-html="paymentMethodTilesHeading" />

        <div class="row payment-methods">
            <div class="payment-method">
                <Box
                    id="payment-blik"
                    :name="'currentMethod'"
                    :chosen="paymentMethods.BLIK === paymentMethod"
                    v-validate="validationRules.listItemValidation(!isValidPaymentMethod())"
                    data-vv-scope="one-time-payment-form"
                    @click="selectPaymentMethodItem(paymentMethods.BLIK)"
                >
                    <img class="blik-logo" src="../../assets/images/blik.svg" alt="blik" title="blik"/>
                </Box>
            </div>
            <div class="payment-method">
                <Box
                    id="payment-online"
                    :chosen="paymentMethods.ONLINE === paymentMethod"
                    @click="selectPaymentMethodItem(paymentMethods.ONLINE)">
                    <div>
                        <p class="text-uppercase">Wpłata online</p>
                        <p class="details">przelew / karta<br>Apple Pay<span v-if="isNobleGift"> / Visa Mobile</span></p>
                    </div>
                </Box>
            </div>
            <div class="payment-method">
                <Box
                    id="payment-traditional"
                    :chosen="paymentMethods.DRUK === paymentMethod"
                    @click="selectPaymentMethodItem(paymentMethods.DRUK)">
                    <div>
                        <p class="text-uppercase">Wpłata<br>tradycyjna</p>
                        <p class="details">blankiet wpłaty</p>
                    </div>
                </Box>
            </div>
        </div>
        <div class="row payment-methods-error">
            <div class="col-12">
                <Error :fieldName="'one-time-payment-form.currentMethod'"/>
            </div>
        </div>

        <div
            class="button-next pb-3 mb-4">
            <NextButton @click="nextStep">Przechodzę dalej  &gt;</NextButton>
        </div>

        <SafePayment />
    </form>
</template>

<script>
import AInput from '../atoms/AInput'
import PInput from '../atoms/PInput'
import Radio from '../atoms/Radio'
import Box from '../atoms/Box'
import Error from '../atoms/Error'
import NextButton from '../atoms/NextButton'
import { connectToSession } from '@/helpers/connectToSession'
import { validationRules } from '@/helpers/validationRules'
import paymentMethods from '../../constants/paymentMethods'
import OptionTilesHeading from "@/components/atoms/OptionTilesHeading"
import Heading from "@/components/atoms/Heading"
import HorizontalSeparator from "@/components/atoms/HorizontalSeparator"
import SafePayment from "@/components/atoms/SafePayment"
import {mapGetters} from "vuex"
import systemConst from "@SYSTEM_CONSTANTS"
import paymentMethodBinding from "@/constants/paymentMethodBinding"

export default {
    name: 'OneTimeFirstStepForm',
    inject: ['$validator'],
    props: [
        'amounts',
        'paymentType',
    ],
    data () {
        return {
            amountList: this.amounts,
            validationRules,
            isOtherValue: false,
            isBlik: systemConst.SHOW_BLIK_HINT,
            isNobleGift: process.env.VUE_APP_SYSTEM === 'szp',
            paymentAmountTilesHeading: 'Wybieram kwotę wpłaty:',
            paymentMethodTilesHeading: 'Wybieram metodę wpłaty:',
            paymentMethods,
            paymentMethodBinding,
            paymentMethod: null,
        }
    },
    computed: {
        ...mapGetters([
            'configData',
        ]),
        currentAmount: {
            get () {
                return this.$store.state.currentAmount
            },
            set (newValue) {
                this.$store.commit('setCurrentAmount', newValue)
                sessionStorage.setItem('amount', newValue)
            }
        },
        amountOther: {
            get () {
                return this.isOtherValue ? this.currentAmount : ''
            },
            set (value) {
                this.$store.commit('setCurrentAmount', value)
                sessionStorage.setItem('amount', value)
            }
        }
    },
    updated: function () {
        this.isOtherValue = !!this.isAmountOther(+this.$store.state.currentAmount)
    },
    methods: {
        isAmountOther (value) {
            return !this.amountList.includes(+value)
        },
        isValidPaymentMethod () {
            return paymentMethodBinding.isValid(this.paymentMethod, this.paymentType);
        },
        selectPaymentAmountItem (value) {
            this.amountList.includes(+value) ? this.isOtherValue = false : this.isOtherValue = true
            this.$store.commit('setCurrentAmount', value)
            sessionStorage.setItem('amount', value)
        },
        nextStep (e) {
            this.$store.commit('setPaymentMethod', this.paymentMethod)

            connectToSession.dataToSessionStorage(
                this.currentAmount,
                this.amountList,
                this.paymentType,
                this.$store.state.paymentMethod,
                process.env.VUE_APP_PAYMENT_FORM_NAME,
                process.env.VUE_APP_SUCCESS_URL,
                process.env.VUE_APP_FAILURE_URL,
                process.env.VUE_APP_SUCCESS_DIRECT_URL,
                (new URLSearchParams(window.location.search)).get('partner'),
            )
            this.$validator.validateAll('one-time-payment-form').then(result => {
                if (result === true) {
                    this.$router.push('/jednorazowo/krok-2')
                }
            })
        },
        selectPaymentMethodItem (value) {
            this.paymentMethod = value;
        },
    },
    mounted () {
        this.isOtherValue = !!this.isAmountOther(+this.currentAmount)
    },
    activated() {
      this.$store.commit('setPaymentMethod', this.paymentMethod);
    },
    watch: {
      paymentMethod(newVal, oldVal) {
        this.$store.commit('setPaymentMethod', newVal)
      }
    },
    components: {
        Heading,
        AInput,
        PInput,
        Box,
        Radio,
        Error,
        NextButton,
        OptionTilesHeading,
        HorizontalSeparator,
        SafePayment,
    }
}
</script>
